import { number, string } from 'prop-types'
import { kuiperClassNames } from '../utils'

function leftPad(str, length, fillChar) {
  const fill = fillChar.repeat(Math.max(0, length - str.length))
  return `${fill}${str}`
}

function getTimestamp(seconds) {
  const timeUnits = [
    { name: 'hour', lengthInSeconds: 3600 },
    { name: 'minute', required: true, lengthInSeconds: 60 },
    { name: 'second', required: true, lengthInSeconds: 1 },
  ]
  let remainingSeconds = seconds
  return timeUnits
    .map((timeUnit) => {
      const value = Math.floor(remainingSeconds / timeUnit.lengthInSeconds)
      const offset = Math.floor(value * timeUnit.lengthInSeconds)
      remainingSeconds = Math.max(0, remainingSeconds - offset)
      return { ...timeUnit, value }
    })
    .filter((timeUnit) => timeUnit.value > 0 || timeUnit.required)
    .map((timeUnit) => leftPad(`${timeUnit.value}`, 2, '0'))
    .join(':')
}

const TimeDisplay = ({ className = '', seconds = 0 }) => (
  <span className={kuiperClassNames('time-display', className)}>
    {getTimestamp(seconds)}
  </span>
)

TimeDisplay.propTypes = {
  className: string,
  seconds: number,
}

export default TimeDisplay
